/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable no-nested-ternary */
import { PATHS } from "routes/paths";
import { OLD_UTC_DATE } from "utils/constant";
import moment from "moment";
import { useUser } from "hooks/use-user";

export const useGetParentTicketList = (status, callsView) => {
  const user = useUser();
  let path = "/";
  if (status === "closed") {
    path = user.Roles.includes("CC Calls")
      ? PATHS.closedCalls
      : callsView
        ? PATHS.closedCalls
        : PATHS.closedTickets;
  } else if (status === "cancelled") {
    path = user.Roles.includes("CC Calls")
      ? PATHS.cancelledCalls
      : callsView
        ? PATHS.cancelledCalls
        : PATHS.closedTickets;
  } else if (status === "vaultAccess") {
    path = PATHS.vaultAccessTickets;
  } else if (status === "selfAssigned") {
    path = PATHS.selfAssignedTickets;
  } else if (status === "resolved") {
    path = user.Roles.includes("CC Calls")
      ? PATHS.resolvedCalls
      : callsView
        ? PATHS.resolvedCalls
        : PATHS.resolvedTickets;
  } else if (status === "awaiting") {
    path = PATHS.awaitingTickets;
  } else if (status === "open") {
    path = user.Roles.includes("CSM Agent")
      ? PATHS.allServiceAndNonServiceCalls
      : user.Roles.includes("CS Monitoring")
        ? PATHS.csMonitoringOpenCalls
        : user.Roles.includes("CC Calls")
          ? PATHS.openCalls
          : callsView
            ? PATHS.openCalls
            : PATHS.openTickets;
  } else if (status === "all") {
    path = user.Roles.includes("CC Calls")
      ? PATHS.allCalls
      : callsView
        ? PATHS.allCalls
        : PATHS.allTickets;
  } else if (status === "cash") {
    path = callsView ? PATHS.cashCalls : PATHS.cashTickets;
  } else if (status === "assigned") {
    path = user.Roles.includes("CC Calls")
      ? PATHS.assignedCalls
      : callsView
        ? PATHS.assignedCalls
        : PATHS.assignedTickets;
  } else if (status === "allServiceAndNonService") {
    path = PATHS.allServiceAndNonServiceCalls;
  } else if (status === "CSMonitoringOpen") {
    path = PATHS.csMonitoringOpenCalls;
  } else if (status === "CSMonitoringClosed") {
    path = PATHS.csMonitoringClosedCalls;
  } else if (status === "CSMonitoringSelfAssigned") {
    path = PATHS.csMonitoringSelfAssignedCalls;
  } else if (status === "CSMonitoringAssigned") {
    path = PATHS.csMonitoringAssignedCalls;
  } else if (status === "CSMonitoringAll") {
    path = PATHS.csMonitoringAllCalls;
  } else if (status === "panicAlert") {
    path = PATHS.panicAlertCalls;
  } else if (status === "accidentReporting") {
    path = PATHS.accidentIncidentCalls;
  } else if (user.Roles.includes("CS Monitoring")) {
    path = PATHS.csMonitoringAllCalls;
  } else if (
    user.Roles.includes("CC Calls") ||
    user.Roles.includes("CSM Agent")
  ) {
    path = PATHS.allCalls;
  } else if (
    user.Roles.includes("SLM Engineer Dispatcher") ||
    user.Roles.includes("Call Out Dispatcher")
  ) {
    path = PATHS.allTickets;
  }
  return path;
};

export const disableTicketEditing = (status) => {
  if (
    status === "Cancelled" ||
    status === "Closed" ||
    status === "In Progress" ||
    status === "Resolved" ||
    status === "Awaiting Customer Approval" ||
    status === "Awaiting Re-Opening"
  )
    return true;
  return false;
};

export const disableTaskEditing = (status) => {
  if (
    status === "Completed" ||
    status === "Awaiting Customer Approval" ||
    status === "Closed" ||
    status === "Cancelled"
  )
    return true;
  return false;
};

export const fixKendoGridContent = (e) => {
  if (e) {
    const tableHeadElm = document.getElementsByClassName("k-table-thead")[0];
    const tableFooterElm = document.getElementsByClassName("k-pager")[0];
    let headerHeight = 0;
    let footerHeight = 0;
    if (tableHeadElm) {
      headerHeight =
        tableHeadElm.getBoundingClientRect().height +
        tableHeadElm.getBoundingClientRect().top;
    }
    if (tableFooterElm) {
      footerHeight = tableFooterElm.getBoundingClientRect().height;
    }
    const container = document.getElementsByClassName("k-grid-container")[0];
    if (container)
      container.style.height = `calc( 100vh - ${headerHeight + footerHeight}px) `;
  }
};

export const getCallOutDepartment = (
  customerShortName,
  activityType,
  region,
  category,
) => {
  if (activityType === "No SLA Activity" && region === "Dubai")
    return "No SLA Activity";

  if (
    [
      "Cash Operations",
      "Bin Clearance",
      "Cash Removal",
      "Replenishment",
      "CIT Manual Collection",
      "Stationary Request",
    ].includes(activityType)
  ) {
    return "Cash Operations";
  }

  if (
    (customerShortName === "GUNNEBO SCDM" &&
      (activityType === "Second Line Maintenance" ||
        activityType === "Phone Support : SLM")) ||
    ((customerShortName === "UBL" ||
      customerShortName === "SNB" ||
      customerShortName === "JBL" ||
      customerShortName === "BSI" ||
      customerShortName === "C 3") &&
      activityType === "Second Line Maintenance") ||
    (customerShortName === "RAK" &&
      activityType === "Second Line Maintenance" &&
      category === "Electronic Pin Pad") ||
    (customerShortName === "DIB" &&
      activityType === "Second Line Maintenance" &&
      category === "Kal Software")
  ) {
    return "Second Line Maintenance";
  }

  return "First Line Maintenance ";
};
export const getRegionForAssignmentGroup = (
  customerShortName,
  type,
  region,
  category,
) => {
  if (
    (customerShortName === "GUNNEBO SCDM" &&
      (type === "Second Line Maintenance" || type === "Phone Support : SLM")) ||
    ((customerShortName === "UBL" ||
      customerShortName === "SNB" ||
      customerShortName === "JBL" ||
      customerShortName === "BSI" ||
      customerShortName === "C 3") &&
      type === "Second Line Maintenance") ||
    (customerShortName === "RAK" &&
      type === "Second Line Maintenance" &&
      category === "Electronic Pin Pad") ||
    (customerShortName === "DIB" &&
      type === "Second Line Maintenance" &&
      category === "Kal Software")
  ) {
    return "All";
  }
  return region;
};

export const isFilterUpdated = (currentFilter, newFilter) => {
  const currentFilters = Object.keys(currentFilter);
  let _isFilterUpdated = false;
  currentFilters.forEach((elm) => {
    if (currentFilter[elm] !== newFilter[elm]) {
      _isFilterUpdated = true;
    }
  });
  return _isFilterUpdated;
};

export const isCallCenterAgent = (user) => {
  return (
    user?.Roles?.includes("Call Center Agent") ||
    user?.Roles?.includes("CCA") ||
    user?.Roles?.includes("CC Calls")
  );
};

export const getCurrentTicketScreen = (dataItem) => {
  if (dataItem.status === "Draft") {
    if (dataItem.activityType === "Facilities Request") {
      return `${PATHS.createFacilityTickets}/${dataItem.ticketId}`;
    }
    if (dataItem.activityType === "Customer Service") {
      return `${PATHS.createCustomerService}/${dataItem.ticketId}`;
    }
    if (dataItem.activityType === "ETISALAT – Third Party") {
      return `${PATHS.createEtisalatThirdParty}/${dataItem.ticketId}`;
    }
    if (dataItem.activityType === "TGM Remote Support") {
      return `${PATHS.createRemoteSupportRequest}/${dataItem.ticketId}`;
    }
    if (dataItem.activityType === "Customer Complaints") {
      return `${PATHS.createCustomerComplaint}/${dataItem.ticketId}`;
    }
    if (dataItem.activityType === "Unusual Event") {
      return `${PATHS.createUnusualEvent}/${dataItem.ticketId}`;
    }
    return `${PATHS.createTicket}/${dataItem.ticketId}`;
  }
  return `${PATHS.ticketDetails}/${dataItem.ticketId}`;
};
export const getTicketDetailsPage = (ticket) => {
  let createTicketPath = PATHS.createTicket;
  let ticketPath = PATHS.ticketDetails;
  const activityType = ticket?.serviceType || ticket.activityType;
  if (activityType === "Facilities Request") {
    createTicketPath = PATHS.createFacilityTickets;
  } else if (activityType === "Customer Service") {
    createTicketPath = PATHS.createCustomerService;
  } else if (activityType === "ETISALAT – Third Party") {
    createTicketPath = PATHS.createEtisalatThirdParty;
  } else if (activityType === "TGM Remote Support") {
    createTicketPath = PATHS.createRemoteSupportRequest;
  } else if (activityType === "Customer Complaints") {
    createTicketPath = PATHS.createCustomerComplaint;
  } else if (activityType === "Unusual Event") {
    createTicketPath = PATHS.createUnusualEvent;
  } else if (activityType === "TGSI Helpdesk") {
    ticketPath = PATHS.tgsiTicketDetails;
    createTicketPath = PATHS.createTGSIHelpDesk;
  } else if (activityType === "Missed And Delayed Services") {
    ticketPath = PATHS.missedDelayedServiceDetails;
    createTicketPath = PATHS.createMissedDelayedService;
  } else if (activityType === "Voice Of Staff") {
    ticketPath = PATHS.voiceOfStaffDetails;
    createTicketPath = PATHS.createVoiceOfStaff;
  } else if (activityType === "Panic Alert Incident") {
    ticketPath = PATHS.panicAlertDetails;
    createTicketPath = PATHS.createPanicAlertIncident;
  } else if (
    activityType === "Incident - Standard" ||
    activityType === "Incident - Emergency"
  ) {
    ticketPath = PATHS.incidentReportingDetails;
    createTicketPath = PATHS.createAccidentIncidentReporting;
  } else if (activityType === "Marketing") {
    ticketPath = PATHS.marketingDetails;
    createTicketPath = PATHS.createMarketing;
  }
  if (ticket.status === "Draft") {
    return `${createTicketPath}/${ticket.ticketId}`;
  }
  return `${ticketPath}/${ticket.ticketId}`;
};

export const StatusLists = {
  Draft: [{ id: "Cancelled", text: "Cancel" }],
  Open: [{ id: "Cancelled", text: "Cancel" }],
  Assigned: [{ id: "Cancelled", text: "Cancel" }],
  Resolved: [
    { id: "Rejected", text: "Reject" },
    { id: "CA Requested", text: "Request Customer Approval" },
  ],
  "Awaiting Customer Approval": [
    { id: "Rejected", text: "Reject" },
    { id: "Closed", text: "Close" },
  ],
  Closed: [{ id: "Re-Opening Requested", text: "Request Re-Opening" }],
  "Awaiting Re-Opening": [{ id: "Re-Opened", text: "Re-Open" }],
  "On Hold": [{ id: "Re-Assigned", text: "Re-Assigned" }],
};

// import { client } from "./api-client";
// export const useGetImage = async (path) => {
//   const isLocal =
//     process.env.REACT_APP_LOCAL_FILE_SYSTEM === "true" ||
//     process.env.REACT_APP_LOCAL_FILE_SYSTEM === true;

//   try {
//     const response = await client(
//       isLocal
//         ? `common/download/local?path=${path}`
//         : `common/download/cloud?url=${path}`,
//       {
//         config: { responseType: "blob" },
//       }
//     );
//     const blob = new Blob([response.data]);
//     const url = URL.createObjectURL(blob);
//     return url;
//   } catch (e) {
//     //empty
//     return "";
//   }
// };
export const getTimeWithAmPm = (isoString) => {
  const dateObj = new Date(isoString);
  return dateObj.toLocaleTimeString("en-US", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
    timeZone: "UTC",
  });
};
export const excelTimestampToJSDate = (excelTimestamp) => {
  let result;

  if (typeof excelTimestamp?.valueOf() === "number") {
    const excelEpoch = new Date(OLD_UTC_DATE);
    if (moment(excelEpoch).isValid()) {
      const millisecondsPerDay = 86400000;
      const totalMilliseconds = excelTimestamp * millisecondsPerDay;
      const jsDate = new Date(excelEpoch.getTime() + totalMilliseconds);

      result = `${moment.utc(jsDate.toISOString()).format("DD/MM/YYYY")} ${getTimeWithAmPm(jsDate.toISOString())}`;
    }
  }
  return result;
};
